$(".sub-category ._iamge").mouseenter(function() {
          
          $(this).find("._title").find("h4").css("top", "78px");
          });
        
$(".sub-category ._iamge").mouseleave(function() {
          
          $(this).find("._title").find("h4").css("top", "20px");
          });